module.exports = __webpack_public_path__ + "media/neck.006739b3.mp4";